import V from 'voca';
import ExpandableTextComponent from '72cms-ui/components/form-elements/ExpandableTextComponent';
import UrlSelectComponent from '72cms-ui/components/form-elements/UrlSelectComponent';
import RadioListComponent from '72cms-ui/components/form-elements/RadioListComponent';
import ScopeSelectComponent from '72cms-ui/components/form-elements/ScopeSelectComponent';
import PageDetailsFormLayout from '72cms-ui/components/form-elements/PageDetailsFormLayout';
import PageDetailsWithScopesFormLayout from '72cms-ui/components/form-elements/PageDetailsWithScopesFormLayout';
import PageBuilderComponent from '72cms-ui/components/helpers/PageBuilderComponent';
import DropdownActionsButtonComponent from '72cms-ui/components/helpers/DropdownActionsButtonComponent';

export default {
    sections: ['details'],
    groups: {
        content_details: {
            component: PageBuilderComponent,
            showOnSection: 'details',
        },
    },
    toolbar: [
        'add', 'edit', 'active', 'delete',
    ],
    fields: {
        name: {
            section: 'details',
            group: 'content_details',
            position: 1,
            description: '',
            cssClass:' lable-lh',
        },

        content: {
            section: 'details',
            group: 'content_details',
            position: 2,
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/form.layout.js